'use strict';

var carouselSettings = require('./einsteinCarousel/einsteinCarouselSettings');

/**
 * Validates and Return the cquotient namespace provided by the commerce cloud platform
 * @returns {Object} - einsteinUtils or null
 */
function getEinsteinUtils() {
    var einsteinUtils = window.CQuotient;
    if (einsteinUtils && (typeof einsteinUtils.getCQUserId === 'function') && (typeof einsteinUtils.getCQCookieId === 'function')) {
        return einsteinUtils;
    }
    return null;
}

/**
 * init slick carousel
 * @param {jQuery} carousel to be initilised
 * @param {Object} settings for carousel
 */
function initCarousel(carousel, settings) {
    if ($(carousel).hasClass('slick-initialized')) {
        $(carousel).slick('unslick');
    }
    $(carousel).slick(settings);
}

/**
 * create slick carousel
 * @param {jQuery} carousel to be slick
 */
function pdSlickCarousel(carousel) {
    var productsCount = $(carousel).find('.product').length;
    var settings;
    settings = carouselSettings.slickCarouselSettings(productsCount, carousel);

    if (settings && Object.keys(settings).length > 0) {
        $(document).ready(function () {
            initCarousel(carousel, settings);
        });

        $(window).on('resize', function () {
            initCarousel(carousel, settings);
        });
        $('body').on('einstein:resize', function () {
            initCarousel(carousel, settings);
        });

        $(carousel).closest('.container').removeClass('d-none');
        var einsteinCarouselWrapper = $(carousel).closest('.container').parent();
        if (einsteinCarouselWrapper.length) {
            einsteinCarouselWrapper.closest('.plp-einstein').removeClass('d-none');
        }

        $(carousel).removeClass('d-none');
    }
}

/**
 * fills in the carousel with product tile html objects
 * @param {string} einsteinResponse string html for product tiles
 * @param {jQuery} $parentElement parent element where recommendations will show.
 */
function fillDomElement(einsteinResponse, $parentElement) {
    var recommender = $parentElement.data('recommender');
    var $staticCarousel = $parentElement.hasClass('static-category-carousel');
    var recommendedProducts = [];
    if ($parentElement.data('render-einstein-recommendations')) {
        recommendedProducts = einsteinResponse[recommender].recs;
        if (!recommendedProducts.length > 0) {
            if ($parentElement.data('static-product-recommendations')) {
                var staticProductRecommendations = $parentElement.data('static-product-recommendations').split(',');
                for (let i = 0; i < staticProductRecommendations.length; i += 1) {
                    recommendedProducts.push({
                        id: staticProductRecommendations[i]
                    });
                }
            }
        }
    } else if ($parentElement.data('static-product-recommendations')) {
        var staticProduct = $parentElement.data('static-product-recommendations').split(',');
        for (let i = 0; i < staticProduct.length; i += 1) {
            recommendedProducts.push({
                id: staticProduct[i]
            });
        }
    }
    if (recommendedProducts && recommendedProducts.length > 0) {
        var template = $parentElement.data('template');

        var components = [];
        components = recommendedProducts.map(function (recommendedProduct) {
            var tiledefinition = {};
            tiledefinition.classxs = $parentElement.data('bsxs');
            tiledefinition.classsm = $parentElement.data('bssm');
            tiledefinition.classmd = $parentElement.data('bsmd');
            tiledefinition.template = template;
            tiledefinition.model = {
                type: 'product',
                id: recommendedProduct.id
            };
            return tiledefinition;
        });

        var url = new URL($parentElement.data('product-load-url'));
        url.searchParams.append('components', JSON.stringify(components));
        url.searchParams.append('limit', $parentElement.data('limit'));
        url.searchParams.append('recommender', recommender);
        url.searchParams.append('isOOSProduct', $staticCarousel);

        $.ajax({
            url: url.href,
            type: 'get',
            dataType: 'html',
            success: function (html) {
                var parsedHtml = $.parseHTML(html);
                $parentElement.find('.py-carousel-inner').removeClass('slick-initialized').html(parsedHtml);
                var recommendationCarousel = $parentElement.find('.py-carousel-inner');
                if (!$staticCarousel && (recommendationCarousel.find('.product').length === 0)) {
                    recommendationCarousel.closest('.plp-einstein').addClass('d-none');
                }
                pdSlickCarousel($parentElement.find('.py-carousel-inner'));
                $('body').trigger('init:wislist');
            },
            error: function () {
                $.spinner().stop();
                if ($parentElement.closest('.plp-einstein').length > 0) {
                    $parentElement.closest('.plp-einstein').carouselSpinner().stop();
                }
            }
        });
    }
}

/**
 * Processes a recommendation tile, with an already initialized category specific anchors array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @param {Object} einsteinUtils cquotient object
 * @param {Array} anchorsArray array of objects representing anchors
 */
function processRecommendationsTile($parentElement, einsteinUtils, anchorsArray) {
    var recommender = $parentElement.data('recommender');

    var params = {
        userId: einsteinUtils.getCQUserId(),
        cookieId: einsteinUtils.getCQCookieId(),
        ccver: '1.01'
    };

    if (anchorsArray) {
        params.anchors = anchorsArray;
    }

    /**
     * Processes a recommendation responses
     * @param {Object} einsteinResponse cquotient object
     */
    function recommendationsReceived(einsteinResponse) {
        fillDomElement(einsteinResponse, $parentElement);
    }

    if (einsteinUtils.getRecs) {
        einsteinUtils.getRecs(einsteinUtils.clientId, recommender, params, recommendationsReceived);
    } else {
        einsteinUtils.widgets = einsteinUtils.widgets || []; // eslint-disable-line no-param-reassign
        einsteinUtils.widgets.push({
            recommenderName: recommender,
            parameters: params,
            callback: recommendationsReceived
        });
    }
}

/**
 * Processes a recommendation tile, with an already initialized product specific anchors array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @returns {Array} - containing an anchor object
 */
function createProductAnchor($parentElement) {
    return [{
        id: $parentElement.data('primaryProductId'),
        sku: $parentElement.data('secondaryProductId'),
        type: $parentElement.data('alternativeGroupType'),
        alt_id: $parentElement.data('alternativeGroupId')
    }];
}

/**
 * Rerieves data attributes from parent element and converts to gretel compatible recommenders array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @returns {Array} - containing an anchor object
 */
function createCategoryAnchor($parentElement) {
    return [{
        id: $parentElement.data('categoryId')
    }];
}

/**
 * Gets all placeholder elements, which hold einstein recommendations queries the details from the
 * einstein engine and feeds them back to the dom element
 */
function loadRecommendations() {
    var einsteinUtils = getEinsteinUtils();
    if (einsteinUtils) {
        var $recommendationTiles = $('.einstein-carousel');
        $recommendationTiles.each(function () {
            var $parentElement = $(this);
            if ($(this).closest('.experience-einstein-einsteinCarouselProduct').length) {
                return processRecommendationsTile($parentElement, einsteinUtils, createProductAnchor($parentElement));
            } if ($(this).closest('.experience-einstein-einsteinCarouselCategory').length) {
                return processRecommendationsTile($parentElement, einsteinUtils, createCategoryAnchor($parentElement));
            }
            return processRecommendationsTile($parentElement, einsteinUtils);
        });
    }
}

$(document).ready(function () {
    loadRecommendations();
});

$('body').on('initializeEinsteinCarousels', function (e, data) {
    if (data && data.parentElement && data.parentElement.length > 0) {
        var einsteinUtils = getEinsteinUtils();
        processRecommendationsTile(data.parentElement, einsteinUtils);
    }
});

$('body').on('initializeEinsteinCarouselsPLP', function () {
    var einsteinUtils = getEinsteinUtils();
    if (einsteinUtils) {
        var $recommendationTiles = $('.einstein-carousel');
        $recommendationTiles.each(function () {
            var $parentElement = $(this);
            var isSlickInitialized = $parentElement.find('.py-carousel-inner').hasClass('slick-initialized');
            if (!isSlickInitialized) {
                processRecommendationsTile($parentElement, einsteinUtils);
            }
        });
    }
});
